import useSupportStore from "../../../store/supportStore";
import { formatDateT } from "../../../../../shared/utils/formatters";
import { formatData } from "../../../utils/supportFormatters";

const stepKey = "spAddress";

const SpAddressMapper = {
  get: () => {
    const store = useSupportStore.getState();
    return store[stepKey] || {};
  },
  set: (data) => {
    const store = useSupportStore.getState();
    store.updateStepFields(stepKey, data);

    const details = {
      "New House Name or Number": data.lookUpAddress?.house,
      "New Postcode": data.postcode?.toUpperCase(),
      "Reason for Changing Address": data.reasonAddress?.label,
      "Will the Vehicle Be Parked on Your Drive Overnight?": data.overNightHome,
      ...(data.overNightHome === "No" && {
        "Where is your vehicle located overnight?": data.locOverNight?.label,
        "What is the overnight postcode?": data.overNightPostcode?.toUpperCase(),
      }),
      "Will Your Vehicle Continue to Be Licensed by the Existing Licensing Authority?":
        data.exitingLicenseAuth,
      ...(data.exitingLicenseAuth === "No" && {
        "What will be the licensing authority?": data.LicenseAuth?.label,
      }),
    };

    const currentChanges = store.Payload.Changes;
    store.updateField("Changes", {
      ...currentChanges,
      Address: {
        Details: details,
        effectiveFrom: formatDateT(data.addressEffectiveDateTime) || "",
        Requested: true,
      },
    });
  },
};

export default SpAddressMapper;
